<div class="bottom-sheet-occasion-container">
  <div class="bottom-sheet-occasion-line-separator"></div>

  <div
    *ngIf="
      data.userCreated?.name && data.userCreated?.photo;
      else noCreatedInfo
    "
    class="bottom-sheet-occasion-user-container"
  >
    <img class="occasion-user-avatar" [src]="data.userCreated?.photo" />
    <p class="occasion-user-text">
      Criado por: <strong>{{ data.userCreated?.name }} </strong> em
      {{ createdAtDay }} às {{ createdAtHour }}.
    </p>
  </div>

  <ng-template #noCreatedInfo
    ><div class="bottom-sheet-occasion-user-container">
      <img
        class="occasion-user-avatar"
        src="../../../../assets/icons/person_outline_black_24dp.svg"
      />
      <p class="occasion-user-text">Informação de criação indisponível.</p>
    </div>
  </ng-template>

  <div *ngIf="data.userUpdated" class="bottom-sheet-occasion-user-container">
    <img class="occasion-user-avatar" [src]="data.userUpdated?.photo" />
    <p class="occasion-user-text">
      Atualizado por: <strong>{{ data.userUpdated?.name }} </strong> em
      {{ updatedAtDay }} às {{ updatedAtHour }}.
    </p>
  </div>

  <div *ngIf="data.releaseDate" class="bottom-sheet-occasion-user-container">
    <div class="ocasion-icon"><mat-icon>schedule_send</mat-icon></div>
    <p class="occasion-user-text">
      Programada para: {{ scheduledDate }} às {{ scheduledHour }}.
    </p>
  </div>
</div>
